import { render, staticRenderFns } from "./AdminTwoFactor.vue?vue&type=template&id=32fad389&scoped=true"
import script from "./AdminTwoFactor.vue?vue&type=script&lang=js"
export * from "./AdminTwoFactor.vue?vue&type=script&lang=js"
import style0 from "./AdminTwoFactor.vue?vue&type=style&index=0&id=32fad389&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fad389",
  null
  
)

export default component.exports